(function () {
  'use strict';

  if (customElements.get('qala-card-carousel')) return;

  class QalaCardCarousel extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.card = this.closest('.card');
      this.images = Array.from(this.querySelectorAll('.qala-card-carousel__img'));
      this.dots = Array.from(this.card?.querySelectorAll('.qala-card-carousel__dot') || []);
      this.count = this.images.length;
      this.index = Math.max(0, this.images.findIndex(image => image.classList.contains('is-active')));
      if (this.count < 2 || this.dots.length !== this.count) return;
      this.show(this.index);

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.show(index);
        }, { signal });
        dot.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = index + 1;
          if (event.key === 'ArrowLeft') next = index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.count - 1;
          if (next === undefined) return;
          event.preventDefault();
          event.stopPropagation();
          this.show(next);
          this.dots[this.index].focus();
        }, { signal });
      });

      this.card.addEventListener('touchstart', event => {
        this.gesture = null;
        if (event.touches.length !== 1) return;
        const touch = event.touches[0];
        const rect = this.getBoundingClientRect();
        if (touch.clientX < rect.left || touch.clientX > rect.right || touch.clientY < rect.top || touch.clientY > rect.bottom) return;
        this.gesture = { x: touch.clientX, y: touch.clientY, horizontal: false };
      }, { passive: true, signal });

      this.card.addEventListener('touchmove', event => {
        if (!this.gesture || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - this.gesture.x;
        const dy = event.touches[0].clientY - this.gesture.y;
        if (!this.gesture.horizontal && Math.abs(dy) > 12 && Math.abs(dy) >= Math.abs(dx)) {
          this.gesture = null;
          return;
        }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          this.gesture.horizontal = true;
          if (event.cancelable) event.preventDefault();
        }
      }, { passive: false, signal });

      this.card.addEventListener('touchend', event => {
        const gesture = this.gesture;
        this.gesture = null;
        if (!gesture?.horizontal || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - gesture.x;
        if (Math.abs(dx) < 35) return;
        this.suppressClickUntil = Date.now() + 500;
        this.show(this.index + (dx < 0 ? 1 : -1));
      }, { passive: true, signal });

      this.card.addEventListener('touchcancel', () => { this.gesture = null; }, { passive: true, signal });
      this.card.addEventListener('click', event => {
        if (Date.now() >= (this.suppressClickUntil || 0)) return;
        const rect = this.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) return;
        event.preventDefault();
        event.stopPropagation();
      }, { capture: true, signal });
    }

    show(index) {
      this.index = ((index % this.count) + this.count) % this.count;
      this.images.forEach((image, i) => {
        image.classList.toggle('is-active', i === this.index);
        image.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-pressed', String(i === this.index));
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.gesture = null;
    }
  }

  customElements.define('qala-card-carousel', QalaCardCarousel);
})();
